import $ from 'jquery';
import _ from 'ext:lodash';
import moment from 'moment';

function updateTime() {
	$('[data-human-time]').each((index, item)=> {
		var element = $(item);
		var date = element.data('human-time');
		if(date) {
			var formattedDate = moment(date, moment.ISO_8601);
			if(formattedDate) {
				element.html('Posted ' + formattedDate.fromNow());
			}
		}
	});
}

export default updateTime;

updateTime();
